export default "__VITE_ASSET__C2$JKxB$__"